import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { fetchLeaves, createLeave } from "store/actions";
import { toast } from "react-hot-toast";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Leave = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [isEdit, setIsEdit] = useState(false);
    const [LeaveTypeId, setLeaveTypeId] = useState(null);
    const [authDetails, setAuthDetails] = useState(null);

    const dispatch = useDispatch();

    const { leaves, loading, error, success } = useSelector((state) => state.leaveReducer || {});

    // Fetch data on component mount
    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        console.log("Final Employee Object:", authUserDetails);
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchLeaves(unitId));
    }, [dispatch]);

    const columns = useMemo(() => {
        const actionColumn = {
            Header: "Action",
            className: "serial-no",
            applyHeaderClass: true,
            Cell: (cellProps) => {
            return (
                <div className="d-flex gap-3">
                <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                >
                    <i className="bx bxs-edit font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                    </UncontrolledTooltip>
                </Link>
                </div>
            );
            },
        };

        return [
            ...(canEdit ? [actionColumn] : []), // 👈 Add Action column only if permission
            {
            Header: "S.No",
            Cell: ({ row }) => leaves.length - row.index,
            className: "serial-no",
            applyHeaderClass: true,
            },
            {
            Header: "Leave Code",
            accessor: "leavecode",
            },
            {
            Header: "Leave Type",
            accessor: "leavetype",
            },
            {
            Header: "Created On",
            accessor: "createddate",
            },
        ];
    }, [leaves, canEdit]);


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            leaveCode: "",
            leaveType: "",
            // description: "",
        },
        validationSchema: Yup.object({
            leaveCode: Yup.string()
                .required("Leave Code is required")
                .max(10, "Leave Code must not exceed 10 characters")
                .matches(
                    /^[a-zA-Z0-9 ]+$/,
                    "Leave Code allows only alphabets, numbers and spaces"
                ),

            leaveType: Yup.string()
                .required("Leave Type is required")
                .max(35, "Leave Type must not exceed 35 characters")
                .matches(
                    /^[a-zA-Z0-9 ]+$/,
                    "Leave Type allows only alphabets, numbers and spaces"
                ),
            // description: Yup.string().required("Description is required"),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Simulate form submit (API call)
                await new Promise((resolve) => setTimeout(resolve, 2000));
                const formData = new FormData();
                formData.append("leave_code", values.leaveCode);
                formData.append("leave_type", values.leaveType);
                formData.append("created_by", authDetails.user_id);
                formData.append("unit_id", authDetails.unit_id);

                if (isEdit) {
                    formData.append("leavetype_id", LeaveTypeId)
                } else {
                    formData.append("leavetype_id", 0);
                }

                dispatch(createLeave(formData)); // Use the same action for both create and update

                setIsEdit(false);
                formik.resetForm();
            } catch (error) {
                console.log('error > ', error)
            } finally {
                setSubmitting(false);
            }
        }
    });

    const handleEdit = (row) => {
        setLeaveTypeId(row.leavetypeid)
        formik.setValues({
            leaveCode: row.leavecode,
            leaveType: row.leavetype,
        });
        setIsEdit(true);
    };

    const handleToggleStatus = (record) => {
        const updatedStatus = !record.isActive;
        console.log(
            `Toggling status of ${record.leaveType} to ${updatedStatus ? "Active" : "Inactive"}`
        );
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Setup" breadcrumbItem="Leave Type" />

                    <Row>
                        <Col lg="12">
                            {(canCreate || canEdit) && (
                            <Card>
                                <CardBody>
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Row>
                                            {/* Leave Code Field */}
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="leaveCode">
                                                        Leave Code <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        id="leaveCode"
                                                        name="leaveCode"
                                                        type="text"
                                                        maxLength={10}
                                                        value={formik.values.leaveCode}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        invalid={formik.touched.leaveCode && formik.errors.leaveCode}
                                                    />
                                                    {formik.touched.leaveCode && formik.errors.leaveCode ? (
                                                        <div className="text-danger">{formik.errors.leaveCode}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>

                                            {/* Leave Type Field */}
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="leaveType">
                                                        Leave Type <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        id="leaveType"
                                                        name="leaveType"
                                                        type="text"
                                                        maxLength={35}
                                                        value={formik.values.leaveType}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        invalid={formik.touched.leaveType && formik.errors.leaveType}
                                                    />
                                                    {formik.touched.leaveType && formik.errors.leaveType ? (
                                                        <div className="text-danger">{formik.errors.leaveType}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>



                                            {/* Submit and Cancel Buttons */}
                                            {/* <Col md={4} sm={12} className="d-flex justify-content-center align-items-center">
                                                <div className="d-flex flex-column flex-md-row w-100 justify-content-center gap-3">
                                                    <Button type="submit" color="primary" className="mb-2 mb-md-0">
                                                        {isEdit ? "Update" : "Save"}
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="secondary"
                                                        onClick={() => {
                                                            formik.resetForm();
                                                            setIsEdit(false);
                                                        }}
                                                        className="mb-2 mb-md-0"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col> */}
                                            <Col className="d-flex align-items-center justify-content-end mb-3">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className="btn button-save me-2 mb-2"
                                                    disabled={formik.isSubmitting}  
                                                >  <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                                                    {/* {formik.isSubmitting ? (
                                                        <>
                                                            <Spinner size="sm" /> Processing... 
                                                        </>
                                                    ) : (
                                                        isEdit ? "Update" : "Save"
                                                    )} */}
                                                </Button>                                               
                                                    <Button
                                                        type="button"
                                                        color="secondary"
                                                        className="btn button-cancel mb-2"
                                                        onClick={() => {
                                                            Swal.fire({
                                                                title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                                                                showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    formik.resetForm();
                                                                    setIsEdit(false);
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-sync me-1" /> Cancel
                                                    </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            )}

                            <Card>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={leaves && leaves.length > 0 ? leaves : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Leave;